import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    hasViewedIntro: false,
    hasViewedExpertIntro: false,
};

const AppStateSlice = createSlice({
    name: 'AppState',
    initialState,
    reducers: {
        setViewedIntro: (state, action) => {
            state.hasViewedIntro = action.payload;
        },
        setViewedExpertIntro: (state, action) => {
            state.hasViewedExpertIntro = action.payload;
        },
        setViewedDescription: (state, action) => {
            state.hasViewedDescription = action.payload;
        },
    },
});

export const { setLoggedIn, setViewedIntro, setViewedExpertIntro, setViewedDescription } = AppStateSlice.actions;
export default AppStateSlice.reducer;
